<span class="number-ticker">{{displayValue}}</span>